// document.querySelectorAll('.static-page p').forEach(p => {
//     const content = p.innerHTML.trim();
//
//     // remove empty / nbsp-only paragraphs
//     if (content === '' || content === '&nbsp;') {
//         p.remove();
//         return;
//     }
//
//     // add spacing to real paragraphs
//     p.style.marginBottom = '20px';
// });

function syncImageHeightToLeft() {

    const images = document.querySelectorAll('.digital-systems-img, .founders-img');

    // Reset first
    images.forEach(img => {
        img.style.height = '';
        img.style.maxHeight = '';
        img.style.width = '';
    });

    if (window.innerWidth <= 1200) return;

    requestAnimationFrame(() => {

        const left = document.querySelector('.left-wrapper');
        const img = document.querySelector('.digital-systems-img');

        if (left && img) {
            const leftHeight = left.getBoundingClientRect().height;
            img.style.height = leftHeight + 'px';
            img.style.objectFit = 'cover';
        }

        const left2 = document.querySelector('.left-wrapper-2');
        const img2 = document.querySelector('.founders-img');

        if (left2 && img2) {
            const leftHeight2 = left2.getBoundingClientRect().height;
            img2.style.height = leftHeight2-5 + 'px';
            img2.style.objectFit = 'cover';
        }

    });
}

// Run on load
window.addEventListener('load', syncImageHeightToLeft);

// Debounced resize
let resizeTimeout;
window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(syncImageHeightToLeft, 100);
});


jQuery(function ($) {

    const $select = $('#newsSelect');
    console.log($select)
    const $btn = $select.find('.MBSelect__btn');
    const $dropdown = $select.find('.MBSelect__dropdown');
    const $items = $select.find('.MBSelect__item');
    const $value = $select.find('.MBSelect__value');

    // Toggle dropdown
    $btn.on('click', function (e) {
        e.stopPropagation();
        // $dropdown.toggle();
        $select.toggleClass('is-open');
    });

    // Select option
    $items.on('click', function () {
        const text = $(this).text();
        $value.text(text);
        // $dropdown.hide();
        $select.removeClass('is-open');
    });

    // Close when clicking outside
    $(document).on('click', function (e) {
        if (!$select.is(e.target) && $select.has(e.target).length === 0) {
            // $dropdown.hide();
        }
    });

});